<template>
  <article class="datatable">
    <table-header
      v-if="header"
      :per-page="getPerPage"
      :filters="filters"
      @updateFilter="updateFilter($event)"
    />
    <component
      :is="tableType"
      :columns="columns"
      :rows.sync="rows"
      :expand="expand"
      :filterBy="getFilter"
      :rowData.sync="rowData"
      @edit="$emit('edit', $event)"
      @sort="$emit('sort', $event)"
      @remove="$emit('remove', $event)"
      @refresh="$emit('change', $event)"
    />
  </article>
</template>

<script>
import Vue from 'vue'
import tableHeader from '@/components/tables/tableHeader'
import tableDefault from '@/components/tables/tableDefault'
import tableFinances from '@/components/tables/tableFinances'
import tableProcedures from '@/components/tables/tableProcedures'
import tableReports from '@/components/tables/tableReports'
import { mapGetters } from 'vuex'

window.Vue = Vue
export default {
  props: [ 'columns', 'rows', 'header', 'perPage', 'filters', 'rowData', 'expand', 'type' ],
  components: {
    tableHeader,
    tableDefault,
    tableFinances,
    tableProcedures,
    tableReports
  },
  data () {
    return {
      refresh: false,
      page: 1,
      loaded: false,
      filter: {},
      returnFilter: '',
      localRows: []
    }
  },
  mounted () {
    for (let filter in this.filters) {
      this.filter[filter] = ''
    }
    this.fn_HIDE_PROGRESS()
    this.$forceUpdate()
  },
  computed: {
    ...mapGetters({
      office: 'getCurrentOffice'
    }),

    tableType () {
      return this.type || 'tableDefault'
    },
    getRows () {
      return this.localRows
    },
    getPerPage () {
      return this.perPage
    },
    getFilter () {
      return this.returnFilter
    }
  },
  watch: {
    rows (next, from) {
      if (next) {
        this.localRows = next
      }
    },
    rowData (next, from) {
      if (next) {
        this.loaded = next
      }
    }
  },
  methods: {
    updateFilter (v) {
      let returnFilter = ''
      for (let filter in this.filters) {
        if (filter === v.name) {
          this.filter[filter] = v.value
        }
      }
      for (let filter in this.filter) {
        returnFilter = returnFilter + ' ' + (this.filter[filter] || '')
      }
      this.returnFilter = returnFilter
    }
  }
}
</script>
